import { useState } from "react";

export default function ServiceFAQ({ items = [] }) {
  const [openIndex, setOpenIndex] = useState(null);

  if (!items.length) return null;

  return (
    <section className="px-8 md:px-[60px] py-12 bg-white">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-center">
          Frequently asked questions
        </h2>
        <div className="divide-y divide-gray-200 border-t border-gray-200">
          {items.map((item, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div key={idx} className="py-5">
                <button
                  onClick={() => setOpenIndex(isOpen ? null : idx)}
                  className="w-full flex justify-between items-start gap-4 text-left group"
                  aria-expanded={isOpen}
                >
                  <span className="text-base md:text-lg font-semibold text-gray-900 group-hover:text-blue-600 transition-colors">
                    {item.q}
                  </span>
                  <span className="flex-shrink-0 mt-0.5 text-gray-500 group-hover:text-blue-600 transition-colors">
                    {isOpen ? (
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                      </svg>
                    ) : (
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    )}
                  </span>
                </button>
                <div className={`mt-4 ${isOpen ? "block" : "hidden"}`}>
                  <p className="text-gray-600 text-base leading-relaxed">
                    {item.a}
                  </p>
                  {item.link && item.linkLabel && (
                    <a
                      href={item.link}
                      className="mt-3 inline-block text-sm font-semibold text-blue-600 hover:text-blue-800 transition-colors"
                    >
                      {item.linkLabel} →
                    </a>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
